import React from 'react'

import moment from 'moment'

import { Paper, Typography, makeStyles } from '@material-ui/core'

import {
  PersonOutlineOutlined,
  CollectionsBookmarkOutlined,
} from '@material-ui/icons'

import { getBaseURL } from 'service/env'
import Footer from './../Footer'
import CartItem from './../Cart/components/CartItem'
import CustomerStaticForm from './../../CustomerStaticForm'
import * as service from 'service'
import contract from 'images/subscribe/contract.png'
import helpers from 'helpers'
import useLoader from 'hooks/useLoader'
import useWindowSize from 'hooks/useWindowSize'
import useSnackbar from 'hooks/useSnackbar'
import useSubscribe from 'hooks/useSubscribe'
import styles from './styles'

const useStyles = makeStyles(styles)

const TitleSection = ({ icon: Icon, title }) => {
  const classes = useStyles()

  return (
    <div className={classes.titleSectionRoot}>
      <Icon color="primary" className={classes.titleSectionIcon} />
      <Typography
        variant="h4"
        color="primary"
        className={classes.titleSectionText}
      >
        {title}
      </Typography>
    </div>
  )
}

const Contractor = () => {
  const classes = useStyles()
  const subscribe = useSubscribe()

  return (
    <div>
      <TitleSection icon={PersonOutlineOutlined} title="Contratante" />

      <div className={classes.contractorContainer}>
        <CustomerStaticForm
          customer={subscribe.customer}
          formatFields={!subscribe.authenticatedWithEmail}
          showTitles={false}
          showEdit={false}
        />

        <img alt="Contrato" src={contract} className={classes.image} />
      </div>
    </div>
  )
}

const Plans = () => {
  const classes = useStyles()
  const subscribe = useSubscribe()

  return (
    <div>
      <TitleSection
        icon={CollectionsBookmarkOutlined}
        title="Planos contratados"
      />

      {subscribe.cart.map((item, index) => (
        <CartItem
          item={item}
          component={Paper}
          key={`${item.id}${index}`}
          disableActions
          className={classes.cartItem}
        />
      ))}
    </div>
  )
}

const Summary = () => {
  const classes = useStyles()
  const windowSize = useWindowSize()
  const subscribe = useSubscribe()

  const totalCart = React.useMemo(
    () => helpers.currency(subscribe.totalCart, { hideSymbol: true }),
    [subscribe.totalCart],
  )

  return (
    <Paper elevation={windowSize.isDesktop ? 0 : 1} className={classes.summary}>
      <Typography color="textSecondary" className={classes.textSummary}>
        Total da sua primeira fatura
      </Typography>

      <div className={classes.priceBox}>
        <Typography className={classes.price}>
          <Typography component="span" className={classes.pricePrefix}>
            R$
          </Typography>

          {totalCart}
        </Typography>
      </div>
    </Paper>
  )
}

const Contract = () => {
  const classes = useStyles()
  const windowSize = useWindowSize()
  const loader = useLoader()
  const snackbar = useSnackbar()
  const subscribe = useSubscribe()
  const [isLoading, setIsLoading] = React.useState(false)

  const handleClickNext = async () => {
    try {
      setIsLoading(true)

      loader.open({
        title: 'Aguarde...',
        align: 'flex-start',
        message: 'Estamos gerando o seu contrato.',
      })

      const contractResponse = await service.recurrence.contracts.create({
        customerId: subscribe.customer.id,
        sellerId: subscribe.seller.id,
        sellerCode: subscribe.seller.code,
        contract: {
          dayExpiration: moment().date(),
          plans: subscribe.cart.map(item => ({
            code: item.code,
            quantity: 0,
          })),
        },
      })

      const contract = contractResponse.data.contract
      const invoice = contract.invoices[0]

      setIsLoading(false)

      loader.open({
        title: 'Contratação realizada com sucesso!',
        align: 'flex-start',
        message:
          'Aguarde, em instantes você será redirecionado para realizar o pagamento.',
      })

      setTimeout(() => {
        subscribe.clearCart()
        service.storage.removeRecurrenceAuthTokenCustomer()

        window.location.assign(
          `${getBaseURL('recurrenceLegacyPortal')}/payment/invoice/${
            invoice.id
          }`,
        )
      }, 5000)
    } catch (error) {
      setIsLoading(false)

      loader.hide()

      snackbar.open({
        variant: 'error',
        message: 'Ocorreu algum erro ao finalizar contrato! Tente novamente!',
      })
    }
  }

  return (
    <div>
      <div className={classes.container}>
        <Paper
          elevation={windowSize.isDesktop ? 1 : 0}
          className={classes.content}
        >
          <Typography
            variant="h4"
            color="textSecondary"
            className={classes.title}
          >
            Contratação
          </Typography>

          <Contractor />

          <Plans />

          <Summary />
        </Paper>
      </div>

      <Footer
        nextButtonText={isLoading ? 'Carregando...' : 'Efetuar pagamento'}
        nextButtonProps={{
          onClick: handleClickNext,
          disabled: isLoading,
        }}
      />
    </div>
  )
}

export default Contract
